function Protocol(meta = {}) {
    return Object.assign({}, meta);
}
export default Protocol;
//# sourceMappingURL=protocol.js.map